import React, { useState, useEffect } from "react";
import { Box, TextField } from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import Header from "../../../components/Header";
import { useAlert } from "../../../global/AlertContext";
import { useNavigate, useParams } from "react-router-dom";
import ErrorComponent from "../../../components/ErrorComponent";
import LoadingComponent from "../../../components/LoadingComponent";
import SuccessButton from "../../../components/SuccessButton";
import CancelButton from "../../../components/CancelButton";
import { useGetSupplierByIdQuery, useUpdateSupplierMutation } from "../../../services/supplierService";

const EditSupplier = () => {
  const showAlert = useAlert();
  const navigate = useNavigate();
  const { id } = useParams();

  const { data: supplier, isLoading, error, refetch } = useGetSupplierByIdQuery(id);
  const [updateSupplier] = useUpdateSupplierMutation();

  const [initialValues, setInitialValues] = useState({
    name: "",
    contact_info: ""
  });

  useEffect(() => {
    if (supplier) {
      setInitialValues({
        name: supplier.name,
        contact_info: supplier.contact_info
      });
    }
  }, [supplier]);

  const handleFormSubmit = async (values, { resetForm }) => {
    try {
      await updateSupplier({ id, updatedSupplier: values }).unwrap();
      await refetch();
      showAlert("Proveedor actualizado!", "success");
      navigate('/suppliers'); // Redirect to the suppliers list page
    } catch (error) {
      console.error("Error updating supplier:", error);
      showAlert(error.message, "error");
    }
  };

  const supplierSchema = yup.object().shape({
    name: yup.string().required("Requerido"),
    contact_info: yup.string().required("Requerido")
  });

  if (isLoading) {
    return <LoadingComponent />;
  }

  if (error) {
    return <ErrorComponent />;
  }

  return (
    <Box m="20px">
      <Header title="Editar Proveedor" subtitle="Editar detalles del proveedor" />
      <Formik
        onSubmit={handleFormSubmit}
        initialValues={initialValues}
        validationSchema={supplierSchema}
        enableReinitialize
      >
        {({ values, errors, touched, handleBlur, handleChange, handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <Box
              display="grid"
              gap="30px"
              gridTemplateColumns="repeat(4, minmax(0, 1fr))"
            >
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Nombre del Proveedor"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.name}
                name="name"
                error={!!touched.name && !!errors.name}
                helperText={touched.name && errors.name}
                sx={{ gridColumn: "span 2" }}
              />
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Información de Contacto"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.contact_info}
                name="contact_info"
                error={!!touched.contact_info && !!errors.contact_info}
                helperText={touched.contact_info && errors.contact_info}
                sx={{ gridColumn: "span 2" }}
              />
            </Box>

            <Box
              display="flex"
              justifyContent="end"
              textAlign="center"
              gap="4px"
              mt="1vh"
            >
              <CancelButton label="Cancelar" onClick={() => navigate('/suppliers')} />
              <SuccessButton label="Actualizar Proveedor" />
            </Box>
          </form>
        )}
      </Formik>
    </Box>
  );
};

export default EditSupplier;
